<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>
<script>
export default {
  name: 'App',
};
</script>
<style lang="scss">
@import url('./styles/icon.scss');
@import url('../materials/questions/common/css/icon.scss');
@import url('./styles/reset.scss');

html {
  font-size: 50px;
}

html,
body,
#app {
  width: 100%;
  height: 100%;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  // font-size: 14px;
}

*,
a:hover * {
  text-decoration: none;
}
.global-messageZindex {
  z-index: 3000 !important;
}
// 滚动条
::-webkit-scrollbar {
  width: 8px;
  height: 10px;
  background-color: #f5f5f5;
}
::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background-color: #ddd;
}
.el-message {
  margin-top: 40px !important;
}
// ------------------------------------------driver样式---------------------------------
.driver-popover.driverjs-theme {
  background-color: #bff1ff;
  color: #000;
  background-image: url(/public/imgs/logo.png) ;
  background-repeat: no-repeat;
  background-size: 50px 50px;
  background-position: calc(100% - 30px) top;
}

.driver-popover.driverjs-theme .driver-popover-title {
  font-size: 20px;
}

.driver-popover.driverjs-theme .driver-popover-title,
.driver-popover.driverjs-theme .driver-popover-description,
.driver-popover.driverjs-theme .driver-popover-progress-text {
  color: #000;
}
.driver-popover.driverjs-theme .driver-popover-description img{
  max-width: 100%;
  height: auto;
}
.driver-popover.driverjs-theme .driver-popover-progress-text{
  margin-right: 10px;
}

.driver-popover.driverjs-theme button {
  width: 100px;
  flex: 1;
  text-align: center;
  background-color: #999 !important;
  color: #ffffff !important;
  border: 2px solid #000;
  text-shadow: none;
  font-size: 14px;
  padding: 5px 8px;
  border-radius: 6px;
}

.driver-popover.driverjs-theme button:hover {
  background-color: #000 !important;
  color: #ffffff !important;
}

.driver-popover.driverjs-theme .driver-popover-navigation-btns {
  justify-content: space-between;
  gap: 3px;
}

.driver-popover.driverjs-theme .driver-popover-close-btn {
  width: 30px;
  font-size: 16px;
  padding: 0;
  color: #000;
  background-color: #fff0;
  border: none;
}

.driver-popover.driverjs-theme .driver-popover-close-btn:hover {
  color: #000;
  background-color: #fff0;
}

.driver-popover.driverjs-theme
  .driver-popover-arrow-side-left.driver-popover-arrow {
  border-left-color: #bff1ff;
}

.driver-popover.driverjs-theme
  .driver-popover-arrow-side-right.driver-popover-arrow {
  border-right-color: #bff1ff;
}

.driver-popover.driverjs-theme
  .driver-popover-arrow-side-top.driver-popover-arrow {
  border-top-color: #bff1ff;
}

.driver-popover.driverjs-theme
  .driver-popover-arrow-side-bottom.driver-popover-arrow {
  border-bottom-color: #bff1ff;
}
</style>
